export const EMPTY_FUNCTION = () => {
    // empty function body
};
